const SET_TYPE_EXPENSES = (state, obj) => {
  state.type_expenses = obj;
};

const SET_COST_CENTERS = (state, obj) => {
  state.cost_centers = obj;
};

const SET_COST_CENTERS_EMPLOYEES = (state, obj) => {
  state.cost_centers_employees = obj;
};

const SET_PAYING_SOURCES = (state, obj) => {
  state.paying_sources = obj;
};

const SET_PROVIDERS = (state, obj) => {
  state.providers = obj;
};

export default {
  SET_TYPE_EXPENSES,
  SET_COST_CENTERS,
  SET_COST_CENTERS_EMPLOYEES,
  SET_PAYING_SOURCES,
  SET_PROVIDERS,
};
